<template>
  <!-- 销售出货单 -->
  <div class="index-container">
    <div class="page-title">销售出货单管理</div>
    <el-button type="primary" class="new-add-button" @click="newAdd">新增预通知单</el-button>
    <el-table border :data="tableData" style="width:100%;overflow:auto;">
      <el-table-column prop="notification_id" label="通知单号"></el-table-column>
      <el-table-column prop="step" label="通知进程"></el-table-column>
      <el-table-column prop="action" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="lookInfo(scope.row)">查看</el-button>
          <el-button size="mini" type="primary" @click="updateInfo(scope.row)">更新</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          <el-button
            size="mini"
            v-if="scope.row.step === '销售填写预通知单'"
            @click="haveProcess(scope.row)"
          >下一流程</el-button>
          <el-button v-if="scope.row.step === '销售填写出货单'" size="mini" @click="haveProcess(scope.row)">下一流程</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page"
      :page-size="10"
      layout="total, prev, pager, next"
      :total="totalPage"
    ></el-pagination>
    <el-dialog title="详情" :visible.sync="detailVisible" width="60%" :close-on-click-modal="false">
      <el-table border :data="detailData" style="width:100%;overflow:auto;">
        <el-table-column prop="date" label="出货日期"></el-table-column>
        <el-table-column prop="sales_name" label="销售助理"></el-table-column>
        <el-table-column prop="agent" label="客户全称"></el-table-column>
        <el-table-column prop="product" label="产品型号"></el-table-column>
        <el-table-column prop="package" label="封装形式"></el-table-column>
        <el-table-column prop="lot" label="发货批号"></el-table-column>
        <el-table-column prop="quantity" label="发货数量"></el-table-column>
        <el-table-column label="快递收件信息">
          <template slot-scope="scope">
            <div>{{scope.row.contact}}</div>
            <div>{{scope.row.phone}}</div>
            <div>{{scope.row.address}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="courier_number" label="快递单号"></el-table-column>
        <el-table-column prop="product" label="出货型号"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="删除" :close-on-click-modal="false" :visible.sync="deleteVisible" width="30%">
      <div class="delete-text">确认删除吗？</div>
      <el-button @click="deleteVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmDelete">确 定</el-button>
    </el-dialog>
  </div>
</template>
<script>
import api from '../api/api';
export default {
  data() {
    return {
      tableData: [
        {
          title: '2324353'
        }
      ],
      dialogVisible: false,
      deleteVisible: false,
      addInfo: {
        question_text: '',
        question_answer: '',
        is_show: ''
      },
      dialogTitle: '新增',
      totalPage: 0,
      page: 1,
      infoId: '',
      detailVisible: false,
      detailData: []
    };
  },

  mounted() {
    this.getList();
  },
  methods: {
    //   完成本流程
    haveProcess(item) {
      const params = {
        notification_id: item.notification_id,
        step: item.step
      };
      api.sendMessage(params).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.$message.success('操作成功！');
        } else {
          this.$message.error(result.msg);
        }
      });
    },
    newAdd() {
      api.addNotification().then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.$message.success('新增成功！');
          this.getList();
        } else {
          this.$message.warning(result.msg);
        }
      });
    },
    updateInfo(item) {
      this.$router.push({
        path: '/orderDetail',
        query: { id: item.notification_id, type: 'pre' }
      });
    },
    lookInfo(item) {
      api
        .getNotificationDetail({ notification_id: item.notification_id })
        .then(res => {
          const result = res.data;
          if (result.code === 0) {
            this.detailData = result.data.details.notification_details;
            this.detailVisible = true;
          } else {
            this.$message.warning(result.msg);
          }
        });
    },
    handleDelete(item) {
      this.infoId = item.id;
      this.deleteVisible = true;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      const params = {
        page: this.page,
        pageSize: 10
      };
      api.getNotificationList(params).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.tableData = result.data.list;
          this.totalPage = result.data.total;
        } else {
          this.$message.warning(result.msg);
        }
      });
    },
    confirmDelete() {
      api.deleteNotification({ id: this.infoId }).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.$message.success('删除成功！');
          this.deleteVisible = false;
          this.getList();
        } else {
          this.$message.error(result.error);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.index-container {
  position: relative;
  flex: 1;
  padding: 32px;
  overflow: auto;
  .page-title {
    padding-bottom: 20px;
    font-size: 24px;
  }
  .table-img {
    cursor: pointer;
  }
  .new-add-button {
    position: absolute;
    top: 32px;
    right: 32px;
    height: 30px;
    padding: 0 20px;
    line-height: 30px;
  }
  .img-style {
    display: block;
    height: 300px;
    margin: 0 auto;
  }
  .delete-text {
    padding-bottom: 30px;
  }
  /deep/ .el-dialog__body {
    overflow: auto;
  }
  /deep/ .el-table .cell {
    max-height: 200px;
    text-align: center;
    overflow: auto;
  }
  /deep/ .el-pagination {
    padding-top: 20px;
    text-align: right;
    .number,
    .el-pagination__total {
      font-size: 18px;
    }
  }
  .info-value-box {
    padding-bottom: 20px;
  }
  .info-title {
    padding-bottom: 10px;
    font-size: 16px;
    span {
      color: crimson;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/salesList.vue